import { Identifiable, RecordModel } from "../core";

export interface INotification extends Identifiable {
  title: string;
  body?: string;
  link?: string;
  category?: string;
  seen_at?: string | null;
}

export const NotificationModel: RecordModel<INotification> = {
  name: "Notification",
  path: "notifications",
  selectQuery: "",
  tableQuery: "",
  toString: r => r.title,
  // No fieldModels needed: notifications are one row per recipient now, and
  // the `user` FK auto-resolves to UserModel by the naming convention. The old
  // {'seen_by': 'Users'} entry died with the users/seen_by M2Ms.
}
